document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-slider]').forEach((slider) => {
    const slides = Array.from(slider.querySelectorAll('.slide'));
    const dots = Array.from(slider.querySelectorAll('[data-slider-dot]'));
    const prev = slider.querySelector('[data-slider-prev]');
    const next = slider.querySelector('[data-slider-next]');
    let current = 0;
    let timer;

    const goTo = (index) => {
      if (slides.length < 2) return;
      slides[current].classList.remove('active');
      dots[current]?.classList.remove('active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('active');
      dots[current]?.classList.add('active');
    };

    const restart = () => {
      window.clearInterval(timer);
      if (slides.length > 1) timer = window.setInterval(() => goTo(current + 1), 5200);
    };

    prev?.addEventListener('click', () => { goTo(current - 1); restart(); });
    next?.addEventListener('click', () => { goTo(current + 1); restart(); });
    dots.forEach((dot) => dot.addEventListener('click', () => {
      goTo(Number(dot.dataset.sliderDot));
      restart();
    }));

    let startX = 0;
    slider.addEventListener('touchstart', (event) => {
      startX = event.touches[0].clientX;
    }, { passive: true });
    slider.addEventListener('touchend', (event) => {
      const delta = event.changedTouches[0].clientX - startX;
      if (Math.abs(delta) > 50) {
        goTo(current + (delta < 0 ? 1 : -1));
        restart();
      }
    }, { passive: true });

    restart();
  });

  const drawer = document.querySelector('[data-drawer]');
  const overlay = document.querySelector('[data-drawer-overlay]');
  const openButton = document.querySelector('[data-drawer-open]');
  const closeButton = document.querySelector('[data-drawer-close]');

  const openDrawer = () => {
    drawer?.classList.add('open');
    overlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    drawer?.classList.remove('open');
    overlay?.classList.remove('open');
    document.body.style.overflow = '';
  };

  openButton?.addEventListener('click', openDrawer);
  closeButton?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);
  document.querySelectorAll('.drawer-nav a').forEach((link) => {
    link.addEventListener('click', () => {
      window.setTimeout(closeDrawer, 80);
    });
  });

  document.querySelectorAll('.card-swatches').forEach((group) => {
    group.addEventListener('click', (event) => {
      const swatch = event.target.closest('.swatch');
      if (!swatch) return;
      event.preventDefault();
      group.querySelectorAll('.swatch').forEach((item) => item.classList.remove('active'));
      swatch.classList.add('active');
    });
  });

  const pageView = document.querySelector('[data-dynamic-page]');

  const closeDynamicPage = () => {
    if (!pageView) return;
    pageView.hidden = true;
    document.body.classList.remove('dynamic-page-open');
    pageView.querySelectorAll('[data-page-panel]').forEach((panel) => {
      panel.classList.remove('active');
    });
    document.querySelectorAll('[data-page-link]').forEach((link) => {
      link.classList.remove('active');
    });
  };

  const showDynamicPage = (panelId, shouldScroll = true) => {
    const target = document.querySelector(`[data-page-panel="${panelId}"]`);
    if (!target || !pageView) return false;

    pageView.hidden = false;
    document.body.classList.add('dynamic-page-open');
    document.body.classList.remove('product-page-open');
    document.body.classList.remove('collection-page-open');
    const productArea = document.querySelector('[data-product-page]');
    if (productArea) productArea.hidden = true;
    const collectionArea = document.querySelector('[data-collection-page]');
    if (collectionArea) collectionArea.hidden = true;
    pageView.querySelectorAll('[data-page-panel]').forEach((panel) => {
      panel.classList.toggle('active', panel === target);
    });
    document.querySelectorAll('[data-page-link]').forEach((link) => {
      link.classList.toggle('active', link.dataset.pageLink === panelId);
    });

    if (shouldScroll) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    return true;
  };

  document.querySelectorAll('[data-page-link]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const panelId = link.dataset.pageLink;
      if (!showDynamicPage(panelId)) return;
      event.preventDefault();
      history.replaceState(null, '', `#${panelId}`);
      closeDrawer();
    });
  });

  document.querySelectorAll('a[href^="#"]:not([data-page-link]):not([data-collection-link])').forEach((link) => {
    link.addEventListener('click', () => {
      closeDynamicPage();
      closeDrawer();
    });
  });

  if (window.location.hash) {
    showDynamicPage(window.location.hash.slice(1), false);
  }

  const productPage = document.querySelector('[data-product-page]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  const cartItemsEl = document.querySelector('[data-cart-items]');
  const cartTotalEl = document.querySelector('[data-cart-total]');
  const cartCountEls = document.querySelectorAll('[data-cart-count]');
  const cartKey = 'lofreeReplicaCart';
  let activeProduct = null;

  const readCart = () => {
    try {
      return JSON.parse(localStorage.getItem(cartKey)) || [];
    } catch (error) {
      return [];
    }
  };

  const writeCart = (cart) => {
    localStorage.setItem(cartKey, JSON.stringify(cart));
  };

  const priceNumber = (price) => {
    const match = String(price || '').replace(',', '.').match(/(\d+(?:\.\d+)?)/);
    return match ? Number(match[1]) : 0;
  };

  const formatMoney = (value) => `$${value.toFixed(2)}`;

  const productSpecs = (title) => {
    const name = title.toLowerCase();
    if (name.includes('switch')) {
      return [
        'Low-profile POM switches',
        'Switch type: Silent linear',
        'Actuation force: 40+10gF',
        'Total travel: 2.8+0.25mm',
        'Responsive keystrokes: 1.3+0.3mm',
        'Durability: 50 million times'
      ];
    }
    if (name.includes('mouse')) {
      return [
        'Wireless desktop mouse design',
        'Comfortable shape for daily work',
        'Smooth tracking for precise movement',
        'Compact profile for a clean setup',
        'Long-lasting rechargeable battery'
      ];
    }
    if (name.includes('keycap')) {
      return [
        'Durable themed keycap set',
        'Designed for mechanical keyboard layouts',
        'Comfortable textured typing surface',
        'Color-matched for expressive desk setups',
        'Easy installation and removal'
      ];
    }
    if (name.includes('mat') || name.includes('rest') || name.includes('numpad') || name.includes('bank')) {
      return [
        'Desk accessory for everyday setups',
        'Soft visual profile with practical function',
        'Designed to match keyboard collections',
        'Compact footprint for clean organization',
        'Made for daily work and play'
      ];
    }
    return [
      'Low-profile mechanical keyboard design',
      'Clean aluminum-inspired desktop profile',
      'Comfortable responsive typing feel',
      'Wireless-ready layout for modern setups',
      'Designed for refined 2m² workspaces'
    ];
  };

  const productFromCard = (card) => ({
    title: card.dataset.productTitle || 'Lofree Product',
    vendor: card.dataset.productVendor || 'LOFREE',
    price: card.dataset.productPrice || '$59.00',
    compare: card.dataset.productCompare || '',
    badge: card.dataset.productBadge || 'NEW',
    review: card.dataset.productReview || '5.0',
    swatches: (card.dataset.productSwatches || 'Default').split(',').map((item) => item.trim()).filter(Boolean),
    image: card.dataset.productImage || '',
    variantId: card.dataset.productVariantId || '',
    art: card.dataset.productArt || 'keyboard'
  });

  const collectionPage = document.querySelector('[data-collection-page]');
  const collectionGrid = document.querySelector('[data-collection-grid]');
  const collectionTitle = document.querySelector('[data-collection-title]');
  const filterPrimary = document.querySelector('[data-filter-primary]');
  const filterOptions = document.querySelector('[data-filter-options]');

  const collectionData = {
    keyboards: {
      title: 'Mechanical Keyboards',
      filter: 'Keyboard Profile',
      options: ['Low-Profile (8)', 'Normal-Profile (13)'],
      products: [
        ['Flow 2 68 Low-profile Mechanical Keyboard', 'From $139.00', '4.6', 'keyboard dark', 'Space Gray, Silver, Sand'],
        ['Flow 2 84 Low-profile Mechanical Keyboard', 'From $159.00', '4.5', 'keyboard dark', 'Space Gray, Silver'],
        ['Flow 2 100 Low-profile Mechanical Keyboard', 'From $169.00', '4.7', 'keyboard dark', 'Space Gray, Silver'],
        ['Lipstick Mechanical Keyboard', 'From $189.00', '4.5', 'keyboard pink', 'Silver, Black'],
        ['Sugar Color 70s Mechanical Keyboard', 'From $139.00', '5.0', 'keyboard transparent', 'Cream, Pink, Blue'],
        ['Block Wireless Mechanical Keyboard', 'From $119.00', '4.8', 'keyboard green', 'Grey/Orange, White'],
        ['Flow Lite84 Low-profile Mechanical Keyboard', '$89.00', '4.6', 'keyboard light', 'Marble, Off-White, Flamingo'],
        ['Edge Mechanical Keyboard', 'From $199.00', '4.8', 'keyboard dark', 'Black, Silver']
      ]
    },
    switches: {
      title: 'Switches',
      filter: 'Key Switch Behavior',
      options: ['Linear (3)', 'Silent Linear (2)', 'Tactile (2)'],
      products: [
        ['Surfer Low-profile POM Switches', '$59.00', '', 'switch light', '106pcs'],
        ['Void Low-profile POM Switches', '$59.00', '5.0', 'switch gray', '106pcs'],
        ['Pulse Low-profile POM Switches', '$59.00', '5.0', 'switch black', '106pcs'],
        ['Phantom Low-profile POM Switches', '$59.00', '4.8', 'switch gray', '106pcs'],
        ['Specter Silent Linear Switches', '$69.00', '4.9', 'switch clear', '106pcs'],
        ['Shadow Tactile Switches', '$59.00', '4.7', 'switch black', '106pcs']
      ]
    },
    keycaps: {
      title: 'Keycaps',
      filter: 'Keycap Profile',
      options: ['PBT (8)', 'Low-profile (4)', 'Theme Set (9)'],
      products: [
        ['Retrowave Keycap Set', 'From $59.00', '4.4', 'keycap purple', 'Neon, Violet'],
        ['Tarot Keycap Set', 'From $59.00', '4.5', 'keycap cream', 'Cream, Ink'],
        ['Mecha Keycap Set', 'From $59.00', '4.2', 'keycap yellow', 'Gray, Yellow'],
        ['Bronze Keycap Set', 'From $59.00', '4.0', 'keycap bronze', 'Bronze, Black'],
        ['Retro Keycap Set', 'From $49.99', '3.9', 'keycap green', 'Cream, Mint'],
        ['Marshmallow Keycap Set', 'From $69.00', '4.8', 'keycap pink', 'Pink, White']
      ]
    },
    mice: {
      title: 'Mice',
      filter: 'Mouse Type',
      options: ['Wireless (4)', 'Gaming (1)', 'Bluetooth (3)'],
      products: [
        ['Pudding Wireless Mouse', '$69.00', '3.0', 'mouse cream', 'Milk, Cocoa'],
        ['Hypace Wireless Gaming Mouse', 'From $159.00', '4.7', 'mouse gray', 'Gray, Black'],
        ['Wavy Chips Bluetooth Mouse', 'From $59.00', '4.8', 'mouse green', 'Olive, Milk, Rose'],
        ['Touch PBT Wireless Mouse', 'From $69.99', '4.3', 'mouse white', 'Tofu, Block'],
        ['Milk Tea Wireless Mouse', '$59.00', '4.4', 'mouse pink', 'Rose, Cream']
      ]
    },
    accessories: {
      title: 'Accessories',
      filter: 'Accessory Type',
      options: ['Desk Mat (2)', 'Palm Rest (2)', 'Numpad (1)', 'Power (2)'],
      products: [
        ['Desk Mat Gray', '$39.00', '5.0', 'accessory mat', 'Gray'],
        ['Desk Mat Black', '$39.00', '', 'accessory black', 'Black'],
        ['Tri-Mode Wireless Numpad', '$79.00', '5.0', 'accessory numpad', 'Silver, Black'],
        ['Cloud Palm Rest', '$39.00', '', 'accessory rest', 'Silver'],
        ['Magnetic Power Bank 5K', '$39.00', '', 'accessory bank', 'Peach, Rose, Amber'],
        ['Keyboard Carrying Case', '$49.00', '4.6', 'accessory case', 'Gray, Black']
      ]
    }
  };

  const closeCollectionPage = () => {
    if (!collectionPage) return;
    collectionPage.hidden = true;
    document.body.classList.remove('collection-page-open');
  };

  const collectionCard = (item) => {
    const [title, price, review, art, swatches] = item;
    const swatchDots = swatches.split(',').slice(0, 3).map((_, index) => `<span class="${index === 0 ? 'active' : ''}"></span>`).join('');
    return `
      <article class="collection-product-card" data-product-card data-product-title="${title}" data-product-vendor="LOFREE" data-product-price="${price}" data-product-badge="NEW" data-product-review="${review || '5.0'}" data-product-swatches="${swatches}" data-product-art="${art.split(' ')[0]}">
        <button type="button" class="collection-product-media" data-product-open aria-label="${title}">
          <span class="collection-badge">NEW</span>
          <span class="collection-art ${art}"></span>
          <span class="quick-add collection-quick" data-quick-add>+ Quick add</span>
        </button>
        <div class="collection-product-info">
          <div class="collection-product-meta"><span>LOFREE</span>${review ? `<span>${review} <b>★</b></span>` : ''}</div>
          <button type="button" data-product-open>${title}</button>
          <p>${price}</p>
          <div class="collection-dots">${swatchDots}</div>
        </div>
      </article>
    `;
  };

  const renderCollection = (key) => {
    const data = collectionData[key] || collectionData.keyboards;
    if (!collectionPage || !collectionGrid || !collectionTitle) return false;
    collectionTitle.textContent = data.title;
    if (filterPrimary) filterPrimary.textContent = data.filter;
    if (filterOptions) {
      filterOptions.innerHTML = data.options.map((option) => `<label><input type="checkbox"> ${option}</label>`).join('');
    }
    collectionGrid.innerHTML = data.products.map(collectionCard).join('');
    return true;
  };

  const showCollectionPage = (key, shouldScroll = true) => {
    if (!renderCollection(key)) return false;
    closeDynamicPage();
    closeProductPage();
    collectionPage.hidden = false;
    document.body.classList.add('collection-page-open');
    document.querySelectorAll('[data-collection-link]').forEach((link) => {
      link.classList.toggle('active', link.dataset.collectionLink === key);
    });
    if (shouldScroll) window.scrollTo({ top: 0, behavior: 'smooth' });
    return true;
  };

  document.querySelectorAll('[data-collection-link]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const key = link.dataset.collectionLink;
      if (!showCollectionPage(key)) return;
      event.preventDefault();
      history.replaceState(null, '', `#${key}`);
      closeDrawer();
    });
  });

  document.querySelectorAll('[data-filter-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      button.closest('.filter-group')?.classList.toggle('open');
    });
  });

  const closeProductPage = () => {
    if (!productPage) return;
    productPage.hidden = true;
    document.body.classList.remove('product-page-open');
  };

  const renderProductMedia = (product) => {
    const media = document.querySelector('[data-product-media]');
    const thumbs = document.querySelectorAll('[data-product-thumb]');
    if (!media) return;

    if (product.image) {
      media.innerHTML = `<img src="${product.image}" alt="${product.title}">`;
      thumbs.forEach((thumb, index) => {
        thumb.style.backgroundImage = `url("${product.image}")`;
        thumb.classList.toggle('active', index === 0);
      });
    } else {
      media.innerHTML = `<div class="product-detail-placeholder detail-art-${product.art || 'keyboard'}"><span></span></div>`;
      thumbs.forEach((thumb, index) => {
        thumb.style.backgroundImage = '';
        thumb.classList.toggle('active', index === 0);
      });
    }
  };

  const showProductPage = (product) => {
    if (!productPage) return;
    activeProduct = product;
    closeDynamicPage();
    closeCollectionPage();
    productPage.hidden = false;
    document.body.classList.add('product-page-open');

    document.querySelector('[data-detail-badge]').textContent = product.badge || 'NEW';
    document.querySelector('[data-detail-title]').textContent = product.title;
    document.querySelector('[data-detail-price]').textContent = product.price;
    document.querySelector('[data-detail-review]').textContent = product.review || '5.0';
    document.querySelector('[data-detail-option-label]').textContent = product.swatches[0] || 'Default';
    document.querySelector('[data-detail-specs]').innerHTML = productSpecs(product.title).map((spec) => `<li>${spec}</li>`).join('');
    document.querySelector('[data-detail-swatches]').innerHTML = product.swatches.map((swatch, index) => (
      `<button type="button" class="${index === 0 ? 'active' : ''}" data-detail-swatch>${swatch}</button>`
    )).join('');
    renderProductMedia(product);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const updateCartUI = () => {
    const cart = readCart();
    const count = cart.reduce((sum, item) => sum + item.qty, 0);
    const total = cart.reduce((sum, item) => sum + priceNumber(item.price) * item.qty, 0);

    cartCountEls.forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });

    if (cartTotalEl) cartTotalEl.textContent = formatMoney(total);
    if (!cartItemsEl) return;

    if (!cart.length) {
      cartItemsEl.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
      return;
    }

    cartItemsEl.innerHTML = cart.map((item) => `
      <div class="cart-line">
        <div class="cart-line-img">${item.image ? `<img src="${item.image}" alt="${item.title}">` : '<span></span>'}</div>
        <div>
          <h3>${item.title}</h3>
          <p>${item.price}</p>
          <div class="cart-qty">
            <button type="button" data-cart-minus="${item.id}">-</button>
            <span>${item.qty}</span>
            <button type="button" data-cart-plus="${item.id}">+</button>
          </div>
        </div>
      </div>
    `).join('');
  };

  const openCart = () => {
    updateCartUI();
    cartDrawer?.classList.add('open');
    if (cartOverlay) cartOverlay.hidden = false;
    document.body.style.overflow = 'hidden';
  };

  const closeCart = () => {
    cartDrawer?.classList.remove('open');
    if (cartOverlay) cartOverlay.hidden = true;
    document.body.style.overflow = '';
  };

  const addToCart = (product) => {
    if (product.variantId) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(product.variantId), quantity: 1 })
      }).catch(() => {});
    }
    const cart = readCart();
    const id = product.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    const existing = cart.find((item) => item.id === id);
    if (existing) {
      existing.qty += 1;
    } else {
      cart.push({ id, title: product.title, price: product.price, image: product.image, qty: 1 });
    }
    writeCart(cart);
    updateCartUI();
    openCart();
  };

  document.addEventListener('click', (event) => {
    const quick = event.target.closest('[data-quick-add]');
    if (quick) {
      const card = quick.closest('[data-product-card]');
      if (!card) return;
      event.preventDefault();
      event.stopPropagation();
      addToCart(productFromCard(card));
      return;
    }

    const opener = event.target.closest('[data-product-open]');
    if (opener) {
      const card = opener.closest('[data-product-card]');
      if (!card) return;
      event.preventDefault();
      showProductPage(productFromCard(card));
      history.replaceState(null, '', `#product-${productFromCard(card).title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`);
    }
  });

  document.querySelector('[data-detail-add]')?.addEventListener('click', () => {
    if (activeProduct) addToCart(activeProduct);
  });

  document.querySelector('[data-detail-swatches]')?.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-detail-swatch]');
    if (!swatch) return;
    swatch.parentElement.querySelectorAll('button').forEach((button) => button.classList.remove('active'));
    swatch.classList.add('active');
    document.querySelector('[data-detail-option-label]').textContent = swatch.textContent;
  });

  document.querySelectorAll('[data-cart-toggle]').forEach((button) => button.addEventListener('click', openCart));
  document.querySelector('[data-cart-close]')?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  cartItemsEl?.addEventListener('click', (event) => {
    const plus = event.target.closest('[data-cart-plus]');
    const minus = event.target.closest('[data-cart-minus]');
    if (!plus && !minus) return;
    const id = plus?.dataset.cartPlus || minus?.dataset.cartMinus;
    const cart = readCart();
    const item = cart.find((line) => line.id === id);
    if (!item) return;
    item.qty += plus ? 1 : -1;
    const nextCart = cart.filter((line) => line.qty > 0);
    writeCart(nextCart);
    updateCartUI();
  });

  document.querySelectorAll('a[href^="#"]:not([data-page-link]):not([data-collection-link])').forEach((link) => {
    link.addEventListener('click', closeProductPage);
  });

  if (window.location.hash && collectionData[window.location.hash.slice(1)]) {
    showCollectionPage(window.location.hash.slice(1), false);
  }

  updateCartUI();
});
